/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function(
	React,
	ReactDOM,
	UI_TOOLKIT,
	PropTypes
) {
	const Container = UI_TOOLKIT.Container;
	const Separator = UI_TOOLKIT.Separator;
	class ToolbarDockComponent extends React.Component{
		static ROOT = 'toolbarDockContainer';
		static propTypes = {
			toolbarDockDOM: PropTypes.shape({
				getProviders: PropTypes.func
			})
		}

		constructor(props){
			super(props);
		}

		_generateSeparator(){
			return <Separator
				className='toolbarDockSeparator'
				orientation='vertical'
				style={{
					margin: '0'
				}}
			/>;
		}

		_generateDocks(){
			if(this.props.toolbarDockDOM.getProviders()){
				let providers = Object.values(this.props.toolbarDockDOM.getProviders());
				providers.sort((firstEl, secondEl) => {
					return firstEl.getIndex() - secondEl.getIndex();
				});
				return providers.map((provider, index) => {
					if(index + 1 === providers.length){
						return provider.getReactElement();
					} else {
						return <React.Fragment>
							{provider.getReactElement()}
							{this._generateSeparator()}
						</React.Fragment>;
					}
				});
			}
		}

		render(){
			return <Container
				className={ToolbarDockComponent.ROOT}>
				{ this._generateDocks() }
			</Container>;
		}
	}

	return ToolbarDockComponent;
});
